import React from "react";
import VerBusinessDetails from "../../../components/common/VerBusinessDetails";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
interface IndiaCorporateBusinessVerificationProps {
  referredByName: string;
}
const IndiaCorporateBusinessVerification: React.FC<
  IndiaCorporateBusinessVerificationProps
> = ({ referredByName }) => {
  const state = useSelector(
    (state: RootState) => state.verification.verBusinessDetails
  );
  if (!state.data || !state.data.data) {
    return <Row>Loading...</Row>;
  }
  const businessDetailsStore = state.data.data.result;
  const isCP = businessDetailsStore.is_counterparty;

  // Function to handle null values and provide default values
  const handleNullValue = (value: null, defaultValue: any) => {
    return value != null ? value : defaultValue;
  };
  return (
    <>
      <Row md={12}>
        <Col md={6}>
          <VerBusinessDetails
            label="Business Registration"
            defaultValue={businessDetailsStore.business_registered_full}
            colored
            required
            // {handleNullValue(
            //   businessDetailsStore.business_registered_with,
            //   "N/A" // Default value for Business Registration
            // )}
          />
        </Col>
        <Col md={6}>
          <VerBusinessDetails
            label="Place of Registration"
            defaultValue={businessDetailsStore.business_registration_place}
            colored={businessDetailsStore.api_business_registration_place_flag}
            required
          />
        </Col>
      </Row>
      <Row md={12}>
        <Col md={6}>
          <VerBusinessDetails
            label="CIN"
            defaultValue={businessDetailsStore.business_cin_no}
            colored={businessDetailsStore.api_cin_flag}
            required
          />
        </Col>
        <Col md={6}>
          <VerBusinessDetails
            label="Incorporation Date"
            defaultValue={businessDetailsStore.business_registration_date}
            colored={businessDetailsStore.api_business_registration_date_flag}
            required
          />
        </Col>
      </Row>{" "}
      <Row md={12}>
        <Col md={12}>
          <VerBusinessDetails
            label="Listing Information"
            defaultValue={
              businessDetailsStore.business_listing_info_ids
                ? businessDetailsStore.business_listing_info_ids
                    .filter(
                      (item: { lov_display_value: string }) =>
                        !!item.lov_display_value
                    )
                    .map(
                      (item: { lov_display_value: string }) =>
                        item.lov_display_value
                    )
                    .join(", ")
                : ""
            }
            required
          />
        </Col>
        <Col md={6}>
          <VerBusinessDetails
            label="Commencement Date"
            defaultValue={businessDetailsStore.business_commencement_date}
          />
        </Col>
      </Row>{" "}
      <Row md={12}>
        <Col md={6}>
          <VerBusinessDetails
            label="LEI"
            defaultValue={businessDetailsStore.business_legal_entity_identifier}
            colored={businessDetailsStore.api_lei_flag}
          />
        </Col>
        <Col md={6}>
          <VerBusinessDetails
            label="Website"
            defaultValue={businessDetailsStore.business_website}
            colored={businessDetailsStore.api_website_flag}
          />
        </Col>
      </Row>
      <Row md={12}>
        <Col md={6}>
          <VerBusinessDetails
            label="Nature of Business"
            defaultValue={
              businessDetailsStore.business_nature
                ? businessDetailsStore.business_nature.charAt(0).toUpperCase() +
                  businessDetailsStore.business_nature.slice(1)
                : null
            }
            required
          />
        </Col>
        <Col md={6}>
          <VerBusinessDetails
            label="Import Export Code"
            defaultValue={businessDetailsStore.business_iecno}
            colored={businessDetailsStore.api_iecno_flag}
            required
          />
        </Col>
      </Row>
      <Row md={12}>
        <Col md={6}>
          <VerBusinessDetails
            label="CKYC No"
            defaultValue={businessDetailsStore.business_ckycno}
          />
        </Col>
        <Col md={6}>
          <VerBusinessDetails
            label="Business Unit Location"
            defaultValue={businessDetailsStore.business_unit_location?.toUpperCase()}
            required
          />
        </Col>
      </Row>
      {businessDetailsStore.business_participant_type === "Seller" && (
        <Row md={12}>
          <Col md={12}>
            <VerBusinessDetails
              label="Star Trading House"
              defaultValue={businessDetailsStore.business_statusholder_full}
              required
            />
          </Col>
        </Row>
      )}
      <Row md={12}>
        <Col md={12}>
          <VerBusinessDetails
            label="Nature of Activity"
            defaultValue={businessDetailsStore.business_nature_activity}
            colored={businessDetailsStore.api_nature_activity_flag}
            required
          />
        </Col>
      </Row>
      {isCP === true && (
        <>
          <Row md={12}>
            <Col md={6}>
              <VerBusinessDetails
                label="Number of Years Relation"
                defaultValue={
                  businessDetailsStore.business_no_of_years_of_relation_with_cp
                }
              />
            </Col>
            <Col md={6}>
              <VerBusinessDetails
                label="Vendor/Dealer Id"
                defaultValue={businessDetailsStore.referred_by_vendor_dealer_id}
              />
            </Col>
          </Row>
          <Row md={12}>
            <Col md={6}>
              <VerBusinessDetails
                label="Is this CP a Related Party?"
                defaultValue={businessDetailsStore.business_is_cp_related_party}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <VerBusinessDetails
                label="Referred By"
                defaultValue={referredByName}
              />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default IndiaCorporateBusinessVerification;
